<app-weather-ui [data]="data"></app-weather-ui>
	<ng-container *ngIf="weatherForecastSchema">
		<script type="application/ld+json">
	        {{ data.weatherForecastSchema | json }}
	      </script>
	</ng-container>